import React, { useState, useEffect, useRef } from 'react';

import { motion, AnimatePresence } from 'framer-motion';
import BorderGlow from '../BorderGlow';
import { useTheme } from '../ThemeProvider';
import { useLanguage } from '../LanguageProvider';
import GlowButton from '../RainbowButton';
import { db } from '../../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { useGamerAuth } from '../GamerAuthContext';
import GamerAuthModal from '../GamerAuthModal';

const CATEGORIES = [
    'DAILY SCRIMS',
    'WEEKLY TOURNAMENTS',
    'MONTHLY MEGA',
    'SPECIAL EVENTS'
];

const PACKAGES_DATA = {
    'DAILY SCRIMS': [
        {
            name: 'Erangel Showdown',
            badge: null,
            featured: false,
            price: '₹ 50',
            basePrice: 50,
            priceSub: 'entry fee',
            desc: 'Daily Solo TPP Matches.',
            features: ['Map: Erangel', 'Mode: Solo TPP', 'Prize: ₹ 1000 Pool', 'No Emulators Allowed'],
            poster: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=800&q=80',
            cta: 'Register Now',
            addons: [
                { id: 'priority_slot', name: 'Priority Slot', price: 20 },
            ],
            btnStyle: 'outline',
        },
        {
            name: 'Squad Battles',
            badge: 'MOST POPULAR',
            badgeColor: 'orange',
            featured: true,
            price: '₹ 150',
            basePrice: 150,
            priceSub: 'entry fee',
            desc: 'Bring your squad.',
            features: ['Map: Miramar', 'Mode: Squad TPP', 'Prize: ₹ 5000 Pool', 'Live Streamed'],
            poster: 'https://images.unsplash.com/photo-1552820728-8b83bb6b773f?auto=format&fit=crop&w=800&q=80',
            cta: 'Register Squad',
            addons: [
                { id: 'team_logo', name: 'Show Team Logo', price: 50 },
            ],
            btnStyle: 'solid',
        },
        {
            name: 'Duo Domination',
            badge: null,
            featured: false,
            price: '₹ 100',
            basePrice: 100,
            priceSub: 'entry fee',
            desc: '2v2 tactical gameplay.',
            features: ['Map: Sanhok', 'Mode: Duo TPP', 'Prize: ₹ 2500 Pool', 'Fast Paced'],
            poster: 'https://images.unsplash.com/photo-1605901309584-818e25960b8f?auto=format&fit=crop&w=800&q=80',
            cta: 'Register Duo',
            addons: [
                { id: 'priority_slot', name: 'Priority Slot', price: 30 },
            ],
            btnStyle: 'outline',
        },
        {
            name: 'Custom Scrims',
            badge: "LET'S TALK",
            badgeColor: 'gray',
            featured: false,
            price: null,
            basePrice: 0,
            priceSub: null,
            desc: 'Host your own scrims.',
            features: ['Custom Rules', 'Private Room', 'Observer Access', 'Dedicated Support'],
            poster: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&w=800&q=80',
            cta: 'Chat with Admin',
            href: 'https://wa.me/919518159114',
            btnStyle: 'outline',
        }
    ],
    'WEEKLY TOURNAMENTS': [
        {
            name: 'Weekend Warrior',
            badge: null,
            featured: false,
            price: '₹ 200',
            basePrice: 200,
            priceSub: 'entry fee',
            desc: 'Intense weekend battles.',
            features: ['Map: All Maps', 'Mode: Squad', 'Prize: ₹ 10,000 Pool', 'Qualifier Rounds'],
            poster: 'https://images.unsplash.com/photo-1538481199005-c710c4fa9e26?auto=format&fit=crop&w=800&q=80',
            cta: 'Register Now',
            addons: [
                { id: 'team_highlight', name: 'Team Highlight', price: 100 }
            ],
            href: 'https://wa.me/919518159114',
            btnStyle: 'outline',
        },
        {
            name: 'Pro League Qualifier',
            badge: 'HIGH STAKES',
            badgeColor: 'orange',
            featured: true,
            price: '₹ 500',
            basePrice: 500,
            priceSub: 'entry fee',
            desc: 'Path to Pro League.',
            features: ['Official Ruleset', 'Mode: Squad FPP', 'Prize: Pro Slot', 'Anti-Cheat Enforced'],
            poster: 'https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?auto=format&fit=crop&w=800&q=80',
            cta: 'Register Squad',
            addons: [
                { id: 'coach_slot', name: 'Coach Slot', price: 150 },
            ],
            href: 'https://wa.me/919518159114',
            btnStyle: 'solid',
        },
        {
            name: 'Underdog Series',
            badge: null,
            featured: false,
            price: '₹ 100',
            basePrice: 100,
            priceSub: 'entry fee',
            desc: 'For rising stars.',
            features: ['Map: Erangel & Miramar', 'Tier Limit: Ace', 'Prize: ₹ 5000', 'No T1 Teams'],
            poster: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=800&q=80',
            cta: 'Register Now',
            addons: [
            ],
            href: 'https://wa.me/919518159114',
            btnStyle: 'outline',
        },
        {
            name: 'Sponsor a Tourney',
            badge: "LET'S TALK",
            badgeColor: 'gray',
            featured: false,
            price: null,
            basePrice: 0,
            priceSub: null,
            desc: 'Brand your own event.',
            features: ['Custom Naming', 'Logo Placement', 'Stream Mentions', 'Giveaways'],
            poster: 'https://images.unsplash.com/photo-1509198397868-475647b2a1e5?auto=format&fit=crop&w=800&q=80',
            cta: 'Chat with Us',
            href: 'https://wa.me/919518159114',
            btnStyle: 'outline',
        }
    ],
    'MONTHLY MEGA': [
        {
            name: 'Monthly Masters',
            badge: 'PREMIUM',
            badgeColor: 'orange',
            featured: true,
            price: '₹ 1000',
            basePrice: 1000,
            priceSub: 'entry fee',
            desc: 'The ultimate showdown.',
            features: ['Map: Competitive Map Pool', 'Format: League + Finals', 'Prize: ₹ 50,000', 'Casted Live'],
            poster: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=800&q=80',
            cta: 'Register Squad',
            addons: [
                { id: 'jersey_design', name: 'Team Jersey Design', price: 500 },
                { id: 'media_kit', name: 'Media Kit', price: 300 }
            ],
            href: 'https://wa.me/919518159114',
            btnStyle: 'solid',
        },
        {
            name: 'TDM Championship',
            badge: null,
            featured: false,
            price: '₹ 300',
            basePrice: 300,
            priceSub: 'entry fee',
            desc: 'Close quarters combat.',
            features: ['Map: Warehouse', 'Format: 4v4 TDM', 'Prize: ₹ 15,000', 'Best of 3'],
            poster: 'https://images.unsplash.com/photo-1552820728-8b83bb6b773f?auto=format&fit=crop&w=800&q=80',
            cta: 'Register Now',
            addons: [
            ],
            href: 'https://wa.me/919518159114',
            btnStyle: 'outline',
        }
    ],
    'SPECIAL EVENTS': [
        {
            name: 'Charity Stream',
            badge: 'FOR A CAUSE',
            badgeColor: 'orange',
            featured: true,
            price: 'Free',
            basePrice: 0,
            priceSub: 'entry',
            desc: 'Play for a good cause.',
            features: ['Fun Modes', 'Invite Only', 'All Proceeds Donated', 'Community Event'],
            poster: 'https://images.unsplash.com/photo-1605901309584-818e25960b8f?auto=format&fit=crop&w=800&q=80',
            cta: 'Join Discord',
            addons: [],
            href: 'https://wa.me/919518159114',
            btnStyle: 'solid',
        },
        {
            name: 'Creator Clash',
            badge: null,
            featured: false,
            price: null,
            basePrice: 0,
            priceSub: null,
            desc: 'Watch your favorite creators.',
            features: ['Influencers Only', 'Special Rules', 'Huge Prize Pool', 'Giveaways for Chat'],
            poster: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&w=800&q=80',
            cta: 'Watch Live',
            addons: [],
            href: 'https://wa.me/919518159114',
            btnStyle: 'outline',
        }
    ]
};

const GAMER_CATEGORIES = [
    'TOP SELLERS',
    'NEW RELEASES',
    'MEGA BUNDLES',
    'SUBSCRIPTIONS'
];

const GAMER_PACKAGES_DATA = {
    'TOP SELLERS': [
        {
            name: 'Random Steam Key',
            badge: null,
            featured: false,
            price: '₹ 149',
            basePrice: 149,
            priceSub: 'per key',
            desc: 'Get a random premium steam game.',
            poster: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=800&q=80',
            features: ['Instant Delivery', 'Global Region', 'No Free Games', 'Value Guaranteed'],
            cta: 'Buy Now',
            addons: [
                { id: 'premium_key', name: 'Premium Tier', price: 200 }
            ],
            btnStyle: 'outline',
        },
        {
            name: 'GTA V Premium',
            badge: 'MOST POPULAR',
            badgeColor: 'orange',
            featured: true,
            price: '₹ 999',
            basePrice: 999,
            priceSub: 'lifetime',
            desc: 'Grand Theft Auto V Premium Edition.',
            poster: 'https://images.unsplash.com/photo-1552820728-8b83bb6b773f?auto=format&fit=crop&w=800&q=80',
            features: ['Full Game Access', 'GTA Online Included', 'Criminal Enterprise Pack', 'Instant Delivery'],
            cta: 'Buy Now',
            addons: [
                { id: 'shark_card', name: 'Megalodon Shark Card', price: 1500 }
            ],
            btnStyle: 'solid',
        },
        {
            name: 'Cyberpunk 2077',
            badge: null,
            featured: false,
            price: '₹ 1,499',
            basePrice: 1499,
            priceSub: 'lifetime',
            desc: 'Welcome to Night City.',
            poster: 'https://images.unsplash.com/photo-1605901309584-818e25960b8f?auto=format&fit=crop&w=800&q=80',
            features: ['Base Game', 'Digital Goodies', 'Global Region', 'Instant Delivery'],
            cta: 'Buy Now',
            addons: [
                { id: 'phantom_liberty', name: 'Phantom Liberty DLC', price: 1200 }
            ],
            btnStyle: 'outline',
        },
        {
            name: 'Custom Order',
            badge: "LET'S TALK",
            badgeColor: 'gray',
            featured: false,
            price: null,
            basePrice: 0,
            priceSub: null,
            desc: 'Looking for a specific game?',
            poster: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&w=800&q=80',
            features: ['Any Steam Game', 'Pre-orders', 'DLCs & Expansions', 'Best Price Guarantee'],
            cta: 'Chat with Us',
            href: 'https://wa.me/919518159114',
            btnStyle: 'outline',
        }
    ],
    'NEW RELEASES': [
        {
            name: 'Fortnite V-Bucks',
            badge: null,
            featured: false,
            price: '₹ 799',
            basePrice: 799,
            priceSub: 'for 1000',
            desc: 'In-game currency for Fortnite.',
            poster: 'https://images.unsplash.com/photo-1538481199005-c710c4fa9e26?auto=format&fit=crop&w=800&q=80',
            features: ['Instant Delivery', 'Global Region', 'Safe Transfer', 'Bonus Offers'],
            cta: 'Buy Now',
            addons: [
                { id: 'extra_1000', name: '+1000 V-Bucks', price: 750 }
            ],
            btnStyle: 'outline',
        },
        {
            name: 'Alan Wake 2',
            badge: 'HOT',
            badgeColor: 'orange',
            featured: true,
            price: '₹ 2,499',
            basePrice: 2499,
            priceSub: 'lifetime',
            desc: 'Survival horror masterpiece.',
            poster: 'https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?auto=format&fit=crop&w=800&q=80',
            features: ['Base Game', 'Pre-order Bonuses', 'Global Region', 'Instant Delivery'],
            cta: 'Buy Now',
            addons: [
                { id: 'deluxe_upgrade', name: 'Deluxe Upgrade', price: 1000 }
            ],
            btnStyle: 'solid',
        },
        {
            name: 'Red Dead Redemption 2',
            badge: null,
            featured: false,
            price: '₹ 1,299',
            basePrice: 1299,
            priceSub: 'lifetime',
            desc: 'Epic tale of life in America.',
            poster: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=800&q=80',
            features: ['Base Game', 'Red Dead Online', 'Global Region', 'Instant Delivery'],
            cta: 'Buy Now',
            addons: [
                { id: 'ultimate_edition', name: 'Ultimate Edition Upgrade', price: 800 }
            ],
            btnStyle: 'outline',
        },
        {
            name: 'Custom Request',
            badge: "LET'S TALK",
            badgeColor: 'gray',
            featured: false,
            price: null,
            basePrice: 0,
            priceSub: null,
            desc: 'Need an Epic Games title?',
            poster: 'https://images.unsplash.com/photo-1509198397868-475647b2a1e5?auto=format&fit=crop&w=800&q=80',
            features: ['Any Epic Game', 'Pre-orders', 'Exclusive Titles', 'Best Price'],
            cta: 'Chat with Us',
            href: 'https://wa.me/919518159114',
            btnStyle: 'outline',
        }
    ],
    'IN-GAME CURRENCY': [
        {
            name: 'Rainbow Six Siege',
            badge: null,
            featured: false,
            price: '₹ 499',
            basePrice: 499,
            priceSub: 'lifetime',
            desc: 'Tactical team-based shooter.',
            poster: 'https://images.unsplash.com/photo-1552820728-8b83bb6b773f?auto=format&fit=crop&w=800&q=80',
            features: ['Standard Edition', 'All Base Operators', 'Global Region', 'Instant Delivery'],
            cta: 'Buy Now',
            addons: [
                { id: 'year_pass', name: 'Year Pass', price: 1200 }
            ],
            btnStyle: 'outline',
        },
        {
            name: 'Assassin\'s Creed Mirage',
            badge: 'NEW',
            badgeColor: 'orange',
            featured: true,
            price: '₹ 2,299',
            basePrice: 2299,
            priceSub: 'lifetime',
            desc: 'Return to the roots.',
            poster: 'https://images.unsplash.com/photo-1605901309584-818e25960b8f?auto=format&fit=crop&w=800&q=80',
            features: ['Base Game', 'Bonus Quest', 'Global Region', 'Instant Delivery'],
            cta: 'Buy Now',
            addons: [
                { id: 'deluxe_pack', name: 'Deluxe Pack', price: 800 }
            ],
            btnStyle: 'solid',
        },
        {
            name: 'Far Cry 6',
            badge: null,
            featured: false,
            price: '₹ 999',
            basePrice: 999,
            priceSub: 'lifetime',
            desc: 'Join the revolution.',
            poster: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&w=800&q=80',
            features: ['Base Game', 'Co-op Supported', 'Global Region', 'Instant Delivery'],
            cta: 'Buy Now',
            addons: [
                { id: 'season_pass', name: 'Season Pass', price: 1000 }
            ],
            btnStyle: 'outline',
        },
        {
            name: 'Ubisoft+ Subscription',
            badge: "LET'S TALK",
            badgeColor: 'gray',
            featured: false,
            price: null,
            basePrice: 0,
            priceSub: null,
            desc: 'Play all new releases.',
            poster: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=800&q=80',
            features: ['100+ PC Games', 'Premium Editions', 'Day 1 Releases', 'Monthly/Yearly'],
            cta: 'Chat with Us',
            href: 'https://wa.me/919518159114',
            btnStyle: 'outline',
        }
    ],
    'SUBSCRIPTIONS': [
        {
            name: 'PSN Wallet Top-up',
            badge: null,
            featured: false,
            price: '₹ 1,000',
            basePrice: 1000,
            priceSub: 'wallet funds',
            desc: 'Add funds to your PSN wallet.',
            poster: 'https://images.unsplash.com/photo-1606144042878-a00e5720993d?auto=format&fit=crop&w=800&q=80',
            features: ['Instant Code Delivery', 'India Region', 'Secure Transfer', 'No Expiry'],
            cta: 'Buy Now',
            addons: [
                { id: 'extra_500', name: '+ ₹ 500 Funds', price: 500 }
            ],
            btnStyle: 'outline',
        },
        {
            name: 'PS Plus Essential',
            badge: 'POPULAR',
            badgeColor: 'orange',
            featured: true,
            price: '₹ 3,949',
            basePrice: 3949,
            priceSub: 'per year',
            desc: 'Online multiplayer & monthly games.',
            poster: 'https://images.unsplash.com/photo-1605901309584-818e25960b8f?auto=format&fit=crop&w=800&q=80',
            features: ['Online Multiplayer', '3 Monthly Games', 'Exclusive Discounts', 'Cloud Storage'],
            cta: 'Buy Now',
            addons: [
                { id: 'extra_tier', name: 'Upgrade to Extra Tier', price: 2800 }
            ],
            btnStyle: 'solid',
        },
        {
            name: 'Spider-Man 2',
            badge: null,
            featured: false,
            price: '₹ 4,999',
            basePrice: 4999,
            priceSub: 'digital code',
            desc: 'Be greater. Together.',
            poster: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=800&q=80',
            features: ['PS5 Digital Code', 'India Region', 'Instant Delivery', 'Pre-order Items'],
            cta: 'Buy Now',
            addons: [
                { id: 'deluxe_upgrade', name: 'Digital Deluxe Upgrade', price: 1000 }
            ],
            btnStyle: 'outline',
        },
        {
            name: 'Custom PSN Order',
            badge: "LET'S TALK",
            badgeColor: 'gray',
            featured: false,
            price: null,
            basePrice: 0,
            priceSub: null,
            desc: 'Need a specific PS4/PS5 game?',
            poster: 'https://images.unsplash.com/photo-1509198397868-475647b2a1e5?auto=format&fit=crop&w=800&q=80',
            features: ['Any PSN Game', 'Region Specific Accounts', 'Pre-orders', 'Best Price'],
            cta: 'Chat with Us',
            href: 'https://wa.me/919518159114',
            btnStyle: 'outline',
        }
    ]
};

const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.1 } },
};

const cardVariants = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

function CheckIcon() {
    return (
        <svg className="h-4 w-4 shrink-0 text-[#FF9500]" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <circle cx="8" cy="8" r="8" fill="rgba(255,149,0,0.12)" />
            <path d="M4.5 8l2.5 2.5 4.5-5" stroke="#FF9500" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

const GLOW_COLORS = ['#FF9500', '#ff6b00', '#ffcc44'];


function PricingCard({ plan, bgColor, activeTab, isFlipped, onFlip, onUnflip, isGameswap, comboMode, isSelected, onToggleSelect, onRequestLogin, pendingCheckout, clearPendingCheckout }) {
    const isGamerStyle = true; // Always apply gamer visual style
    const primaryColor = isGamerStyle ? '#ec4899' : '#FF9500';
    const glowColors = isGamerStyle ? ['#ec4899', '#db2777', '#be185d'] : GLOW_COLORS;
    const hasAddons = !!plan.addons;
    const [selectedAddons, setSelectedAddons] = useState({});
    const [imageLoaded, setImageLoaded] = useState(false);
    const containerRef = useRef(null);
    const hoverRef = useRef(null);

    useEffect(() => {
        const currentContainer = containerRef.current;
        if (!currentContainer || !hasAddons) return;
        
        const timeout = setTimeout(() => {
            let HoverEffect;
            if (typeof window !== 'undefined') {
                 HoverEffect = require('hover-effect').default || require('hover-effect');
            }

            if (HoverEffect && currentContainer) {
                try {
                    hoverRef.current = new HoverEffect({
                        parent: currentContainer,
                        intensity: 0.3,
                        image1: plan.poster || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
                        image2: plan.poster || '/studio_tech.png',
                        displacementImage: '/myDistorsionImage.webp',
                        imagesRatio: 1.5,
                        hover: false,
                    });
                } catch (e) {
                    console.error("HoverEffect error:", e);
                }
            }
        }, 100);

        return () => {
            clearTimeout(timeout);
            if (currentContainer) {
                currentContainer.innerHTML = '';
            }
        };
    }, [hasAddons]);

    useEffect(() => {
        if (hoverRef.current) {
            if (isFlipped) {
                hoverRef.current.next();
            } else {
                hoverRef.current.previous();
            }
        }
    }, [isFlipped]);

    const [livePrice, setLivePrice] = useState(plan.basePrice);
    const [liveAddons, setLiveAddons] = useState(plan.addons || []);

    useEffect(() => {
        setLivePrice(plan.basePrice);
        setLiveAddons(plan.addons || []);
    }, [plan.basePrice, plan.addons]);

    const handleGetStarted = async (e) => {
        if (comboMode) {
            if (e) e.preventDefault();
            onToggleSelect();
            return;
        }
        if (isGameswap && hasAddons) {
            if (e) e.preventDefault();
            onFlip();

            // Fetch live price on click for GAMER tab
            if (!isFlipped && plan.gameswap_id) {
                try {
                    const { doc, getDoc } = await import('firebase/firestore');
                    const { db } = await import('../../firebase');
                    const docRef = doc(db, 'gameswap', 'data', plan.folder || 'covers', plan.docId || String(plan.gameswap_id));
                    const docSnap = await getDoc(docRef);
                    if (docSnap.exists()) {
                        const freshData = docSnap.data();
                        const freshBasePrice = freshData.price || 0;
                        const freshOptions = freshData.options ? freshData.options.map((opt, j) => ({
                            id: `opt_${j}`, name: opt.name, price: opt.price
                        })) : [];
                        
                        setLivePrice(freshBasePrice);
                        setLiveAddons(freshOptions);

                        // Update localStorage
                        const cached = localStorage.getItem('gameswapData_v5');
                        if (cached) {
                            const parsed = JSON.parse(cached);
                            const cat = plan.category || 'TOP SELLERS';
                            const idx = parsed.packages[cat]?.findIndex(p => p.gameswap_id === plan.gameswap_id);
                            if (idx !== undefined && idx !== -1) {
                                parsed.packages[cat][idx].basePrice = freshBasePrice;
                                parsed.packages[cat][idx].price = `₹ ${freshBasePrice.toLocaleString()}`;
                                parsed.packages[cat][idx].addons = freshOptions;
                                localStorage.setItem('gameswapData_v5', JSON.stringify(parsed));
                            }
                        }
                    }
                } catch (err) {
                    console.error("Failed to fetch live price:", err);
                }
            }
        }
    };

    const handleBack = () => {
        setCheckoutStep('addons');
        onUnflip();
    };

    const toggleAddon = (addonId) => {
        const addon = liveAddons.find(a => a.id === addonId);
        if (addon?.required) return;
        
        setSelectedAddons(prev => ({
            ...prev,
            [addonId]: !prev[addonId]
        }));
    };

    const totalPrice = Number(livePrice) + liveAddons.reduce((acc, addon) => {
        const isChecked = addon.required || !!selectedAddons[addon.id];
        return acc + (isChecked ? (Number(addon.price) || 0) : 0);
    }, 0);

    const getWhatsAppLink = () => {
        if (!hasAddons) return plan.href;
        
        let text = `Hi Akshar, I am interested in the ${plan.name} package.`;
        const selectedNames = (plan.addons || []).filter(a => selectedAddons[a.id]).map(a => a.name);
        
        if (selectedNames.length > 0) {
            text += ` I also want the following add-ons: ${selectedNames.join(', ')}.`;
        }
        text += ` Estimated total: ₹ ${totalPrice.toLocaleString()}.`;
        
        return `https://wa.me/919518159114?text=${encodeURIComponent(text)}`;
    };

    const [checkoutStep, setCheckoutStep] = useState('addons'); // 'addons' | 'contact_choice' | 'whatsapp_input' | 'email_input'
    const [contactType, setContactType] = useState(null);
    const [contactInput, setContactInput] = useState('');
    const [countryCode, setCountryCode] = useState('+91 ');
    const [isProcessing, setIsProcessing] = useState(false);

    const { gamerUser, unlockGames } = useGamerAuth();
    const isBanned = gamerUser?.isBanned || false;

    useEffect(() => {
        if (gamerUser && pendingCheckout === plan) {
            handleRazorpayPayment('gamer_profile', gamerUser.gamerCode, '');
            clearPendingCheckout();
        }
    }, [gamerUser, pendingCheckout, plan, clearPendingCheckout]);

    useEffect(() => {
        fetch('https://ipapi.co/country_calling_code/')
            .then(res => res.text())
            .then(code => {
                if (code && code.trim().startsWith('+')) {
                    setCountryCode(code.trim() + ' ');
                }
            })
            .catch(() => {});
    }, []);

    const handleRazorpayPayment = async (cType, cInput, cCode) => {
        if (!window.Razorpay) {
            alert('Razorpay SDK not loaded');
            return;
        }

        try {
            const res = await fetch('https://rpgridlabsprod.gridlabsproduction.workers.dev/api/create-order', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ amount: totalPrice * 100, currency: 'INR', receipt: `receipt_${Date.now()}` })
            });
            const orderData = await res.json();
            if (!res.ok) {
                const errorObj = orderData.error;
                const errDetail = typeof errorObj === 'object' && errorObj !== null ? errorObj.description : errorObj;
                throw new Error(errDetail || 'Failed to create order');
            }

            const options = {
                key: 'rzp_live_T58W4XHqjFJneN',
                amount: orderData.amount,
                currency: orderData.currency,
                name: 'GridLabs Production',
                description: `Payment for ${plan.name}`,
                order_id: orderData.id,
                handler: async function (response) {
                    try {
                        const verifyRes = await fetch('https://rpgridlabsprod.gridlabsproduction.workers.dev/api/verify-payment', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                razorpay_order_id: response.razorpay_order_id,
                                razorpay_payment_id: response.razorpay_payment_id,
                                razorpay_signature: response.razorpay_signature
                            })
                        });
                        const verifyData = await verifyRes.json();
                        if (verifyData.success) {
                            alert('Payment successful!');
                            
                            let text = `Hi Akshar, I have successfully paid for the *${plan.name}* package.\n\n`;
                            text += `*Payment Details:*\n`;
                            text += `- Amount Paid: ₹ ${totalPrice.toLocaleString()}\n`;
                            text += `- Payment ID: ${response.razorpay_payment_id}\n`;
                            if (cType === 'whatsapp') {
                                text += `- My WhatsApp: ${cCode}${cInput}\n\n`;
                            } else {
                                text += `- My Email: ${cInput}\n\n`;
                            }
                            
                            const selectedNames = (plan.addons || []).filter(a => selectedAddons[a.id]).map(a => a.name);
                            if (selectedNames.length > 0) {
                                text += `*Selected Add-ons:*\n- ${selectedNames.join('\n- ')}\n\n`;
                            }
                            
                            text += `Please process my order.`;
                            
                            if (cType === 'whatsapp') {
                                const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                                const waUrl = isMobile 
                                    ? `whatsapp://send?phone=919518159114&text=${encodeURIComponent(text)}`
                                    : `https://web.whatsapp.com/send?phone=919518159114&text=${encodeURIComponent(text)}`;
                                window.location.href = waUrl;
                            } else if (cType === 'gamer_profile') {
                                await unlockGames([plan.docId || String(plan.gameswap_id) || plan.name]);
                                alert('Game unlocked and added to your GAMER profile!');
                                setCheckoutStep('addons');
                                onUnflip();
                            } else {
                                alert('Thank you! Since you preferred email, we have received your order and will email you shortly.');
                            }
                        } else {
                            alert('Payment verification failed!');
                        }
                    } catch (error) {
                        alert('Error verifying payment');
                    }
                },
                prefill: {
                    name: 'Customer',
                    email: cType === 'email' ? cInput : 'whatsapp_user@gridlabsprod.com',
                    contact: cType === 'whatsapp' ? cInput.replace(/\D/g, '') : '9999999999'
                },
                theme: {
                    color: '#FF9500'
                }
            };
            const rzp = new window.Razorpay(options);
            rzp.on('payment.failed', function (response) {
                alert(`Payment Failed: ${response.error.description}`);
            });
            rzp.open();
        } catch (error) {
            console.error('Razorpay Error:', error);
            const errMsg = error?.message || (typeof error === 'object' ? JSON.stringify(error) : String(error));
            alert(`Error: ${errMsg}. Please check the console for more details.`);
        } finally {
            setIsProcessing(false);
        }
    };

    const handlePrePayment = () => {
        setCheckoutStep('contact_choice');
    };

    const handleWhatsAppSelect = () => {
        setContactType('whatsapp');
        setContactInput(countryCode);
        setCheckoutStep('whatsapp_input');
    };

    const handleEmailSelect = () => {
        setContactType('email');
        setContactInput('');
        setCheckoutStep('email_input');
    };

    return (
        <motion.div variants={cardVariants} className={`pricing-card-container relative flex flex-col w-full group perspective-1000 ${isGameswap ? 'h-[340px] sm:h-[360px]' : 'h-[220px] sm:h-[260px] lg:h-[240px]'}`}>
            {plan.badge && (
                <span className="absolute -top-3 right-4 z-20 inline-flex items-center rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider bg-[#FF9500] text-black">
                    {plan.badge}
                </span>
            )}
            
            <BorderGlow edgeSensitivity={22} glowColor={isGamerStyle ? "320 100 60" : "30 100 60"} backgroundColor={bgColor} borderRadius={isGamerStyle ? 4 : 16} glowRadius={32} glowIntensity={isGamerStyle ? 0.4 : (plan.featured ? 1.1 : 0.9)} coneSpread={28} colors={glowColors} className="flex-1 relative">
                
                {/* Tech Accents for GAMER mode */}
                {isGamerStyle && (
                    <div className="absolute inset-0 pointer-events-none z-40">
                        {/* Top Left Accent */}
                        <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-pink-500/70" />
                        <div className="absolute top-1.5 left-1.5 w-1 h-1 bg-pink-500/50" />
                        
                        {/* Bottom Right Accent */}
                        <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-purple-500/70" />
                        <div className="absolute bottom-1.5 right-1.5 w-1 h-1 bg-purple-500/50" />
                        
                        {/* Bottom Left Accent */}
                        <div className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-white/20" />
                        
                        {/* Top Right Accent */}
                        <div className="absolute top-0 right-0 w-2 h-2 border-t border-r border-white/20" />
                    </div>
                )}

                <div className={`absolute inset-0 overflow-hidden w-full h-full z-0 ${isGamerStyle ? 'rounded-[3px]' : 'rounded-[calc(16px-1px)]'}`}>
                    {isGamerStyle && plan.poster && (
                        <div className="absolute inset-0 z-0 pointer-events-none bg-gray-100 dark:bg-[#111]">
                            {!imageLoaded && (
                                <div className="absolute inset-0 bg-gray-200 dark:bg-white/5 animate-pulse" />
                            )}
                            <img 
                                src={plan.poster} 
                                alt="" 
                                className={`w-full h-full object-cover text-transparent transition-opacity duration-500 ease-in-out ${imageLoaded ? 'opacity-100' : 'opacity-0'}`} 
                                onLoad={() => setImageLoaded(true)}
                                onError={(e) => { e.currentTarget.style.display = 'none'; setImageLoaded(true); }}
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-white/90 via-white/50 to-transparent dark:from-black/90 dark:via-[#111]/60 dark:to-transparent" />
                        </div>
                    )}
                    
                    {comboMode && (
                        <div className={`absolute inset-0 z-[45] pointer-events-none transition-all duration-300 ${isSelected ? 'shadow-[inset_0_0_0_3px_#ec4899] bg-pink-500/10' : 'shadow-none'}`}>
                            {isSelected && (
                                <div className="absolute top-4 right-4 bg-pink-500 text-white rounded-full p-1 shadow-[0_0_15px_rgba(236,72,153,0.5)]">
                                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
                                </div>
                            )}
                        </div>
                    )}
                    
                    {/* Background WebGL Container */}
                    {hasAddons && (
                        <>
                            <div ref={containerRef} className="absolute inset-0 z-0 opacity-100" style={{ pointerEvents: 'none' }} />
                            <div className={`absolute inset-0 z-[1] transition-all duration-700 ease-in-out pointer-events-none ${isFlipped ? (isGamerStyle ? 'bg-white/80 dark:bg-black/80 backdrop-blur-md delay-300' : 'bg-white/80 dark:bg-black/60 backdrop-blur-sm delay-300') : 'bg-transparent delay-0'}`} />
                        </>
                    )}
                </div>

                {/* Content Container */}
                <div className="relative z-10 p-6 h-full flex flex-col pointer-events-none">
                    <AnimatePresence mode="wait">
                        {!isFlipped ? (
                            <motion.div 
                                key="front" 
                                initial={{ opacity: 0 }} 
                                animate={{ opacity: 1 }} 
                                exit={{ opacity: 0 }} 
                                transition={{ duration: 0.3 }} 
                                className={`flex flex-col h-full pointer-events-auto ${isGamerStyle ? 'cursor-pointer absolute inset-0' : ''}`}
                                onClick={isGamerStyle ? handleGetStarted : undefined}
                            >
                                {!isGamerStyle && (
                                    <>
                                        <h3 className="text-base font-semibold text-gray-900 dark:text-white">{plan.name}</h3>
                                        <div className="mt-4">
                                            {plan.price ? (
                                                <>
                                                    <span className="text-3xl font-bold text-gray-900 dark:text-white">{plan.price}</span>
                                                    <span className="ml-2 text-sm text-gray-500 dark:text-[#888888]">{plan.priceSub}</span>
                                                </>
                                            ) : (
                                                <>
                                                    <span className="text-3xl font-bold text-gray-900 dark:text-white">Custom pricing</span>
                                                    <p className="mt-1 text-xs text-gray-500 dark:text-[#888888]">Quoted based on your scope.</p>
                                                </>
                                            )}
                                        </div>
                                        <p className="mt-3 text-sm text-gray-500 dark:text-[#888888] leading-relaxed">{plan.desc}</p>
                                        <div className="my-5 h-px bg-gray-100 dark:bg-[#1f1f1f]" />
                                        <ul className="flex flex-col gap-2.5 flex-1">
                                            {plan.features.map((f) => (
                                                <li key={f} className="flex items-start gap-2.5 text-sm text-gray-700 dark:text-[#cccccc]">
                                                    <CheckIcon />
                                                    <span>{f}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                                {!isGameswap && (
                                    <div className="mt-auto w-full pointer-events-auto shrink-0">
                                        <GlowButton 
                                            asLink={!isBanned} 
                                            variant="primary" 
                                            href={!isBanned ? (plan.href || getWhatsAppLink()) : undefined} 
                                            onClick={(e) => { 
                                                e.stopPropagation();
                                                if (isBanned) alert("Your account is currently banned. Please file an Unban Appeal from your profile.");
                                            }} 
                                            target={!isBanned ? "_blank" : undefined} 
                                            rel="noopener noreferrer" 
                                            className={`w-full justify-center text-[13px] font-bold !rounded-none h-12 tracking-widest ${isBanned ? 'opacity-50 !cursor-not-allowed !bg-red-500/20 !text-red-400 border-none before:hidden after:hidden hover:scale-100 hover:rotate-0' : ''}`}
                                        >
                                            {isBanned ? "BANNED" : "REGISTER NOW"}
                                        </GlowButton>
                                    </div>
                                )}
                            </motion.div>
                        ) : (
                            <motion.div key="back" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }} className="flex flex-col h-full justify-between relative z-20 pointer-events-auto">
                                {checkoutStep === 'addons' && (
                                    <>
                                        <div className="flex justify-between items-center mb-3 shrink-0">
                                            <button onClick={handleBack} className="text-sm font-medium transition-colors hover:text-white" style={{ color: primaryColor }}>
                                                Back
                                            </button>
                                            {!isGameswap && (
                                                <span className="text-sm font-medium text-white/90 dark:text-[#888888]">
                                                    Build your package
                                                </span>
                                            )}
                                        </div>
                                        
                                        <div className={`overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] flex-1 ${isGameswap ? '-mx-6' : ''}`}>
                                            <div className={`flex flex-col ${isGameswap ? 'border-t border-white/10' : 'gap-2'}`}>
                                                {liveAddons.map(addon => {
                                                    const isChecked = addon.required || !!selectedAddons[addon.id];
                                                    
                                                    const gameswapClasses = `border-b border-white/10 py-4 px-4 hover:bg-white/5 cursor-pointer transition-colors ${isChecked ? 'bg-pink-500/10' : ''}`;
                                                    const defaultClasses = `p-2.5 rounded-lg border transition-colors bg-white/60 dark:bg-black/40 backdrop-blur-md ${addon.required ? 'border-[#FF9500] cursor-default' : 'border-gray-200 dark:border-gray-800 hover:border-[#FF9500] cursor-pointer'}`;
                                                    
                                                    return (
                                                    <label key={addon.id} onClick={(e) => { e.preventDefault(); toggleAddon(addon.id); }} className={`flex items-center justify-between transition-colors ${isGameswap ? gameswapClasses : defaultClasses}`}>
                                                        <div className="flex items-center gap-2.5">
                                                            <input type="checkbox" className="hidden" checked={isChecked} onChange={() => toggleAddon(addon.id)} disabled={addon.required} />
                                                            {!isGameswap && (
                                                                <div className={`w-4 h-4 rounded border flex items-center justify-center transition-colors ${isChecked ? 'border-transparent' : 'border-gray-300 dark:border-gray-600'}`} style={{ backgroundColor: isChecked ? primaryColor : 'transparent' }}>
                                                                    {isChecked && <svg className="w-3 h-3 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>}
                                                                </div>
                                                            )}
                                                            <span className={`text-sm font-medium ${isGameswap ? (isChecked ? 'text-pink-600 dark:text-pink-400' : 'text-gray-900 dark:text-gray-300') : 'text-gray-700 dark:text-gray-300'}`}>{addon.name}</span>
                                                        </div>
                                                        <span className={`text-sm font-semibold ${isGamerStyle ? (isChecked ? 'text-pink-500 dark:text-pink-400' : 'text-gray-900 dark:text-white') : 'text-gray-900 dark:text-white'}`}>
                                                            {addon.price === 0 ? 'FREE' : `₹ ${addon.price.toLocaleString()}`}
                                                        </span>
                                                    </label>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        <div className="mt-auto pt-3 shrink-0 -mx-6 -mb-6">
                                            <div className={`flex items-end ${isGamerStyle ? 'justify-end' : 'justify-between'} mb-3 px-6`}>
                                                {!isGamerStyle && <span className="text-sm text-gray-700 dark:text-[#888888]">Total Estimated</span>}
                                                <span className="text-2xl font-bold text-gray-900 dark:text-white">₹ {totalPrice.toLocaleString()}</span>
                                            </div>
                                            <GlowButton 
                                                onClick={() => {
                                                    if (isGameswap) {
                                                        if (!gamerUser) {
                                                            onRequestLogin(plan);
                                                        } else {
                                                            handleRazorpayPayment('gamer_profile', gamerUser.gamerCode, '');
                                                        }
                                                        return;
                                                    }
                                                    if (!hasAddons) {
                                                        handleRazorpayPayment('email', 'direct_buy@gridlabsprod.com', '');
                                                        return;
                                                    }
                                                    setCheckoutStep('contact_choice');
                                                }} 
                                                variant="primary" 
                                                className="w-full justify-center text-sm font-bold !rounded-none !rounded-b-[calc(16px-1px)] h-12"
                                                disabled={isProcessing}
                                            >
                                                {isProcessing ? 'Processing...' : (isGameswap ? (activeTab === 'MEGA BUNDLES' ? 'Buy the Bundle' : activeTab === 'SUBSCRIPTIONS' ? 'Buy Subscription' : 'Buy the Game') : 'Buy the Bundle')}
                                            </GlowButton>
                                        </div>
                                    </>
                                )}

                                {checkoutStep === 'contact_choice' && (
                                    <div className="flex flex-col h-full justify-center pb-4">
                                        <h4 className="text-[17px] font-bold text-gray-900 dark:text-white mb-2 text-center">Checkout Details</h4>
                                        <p className="text-[13px] text-gray-600 dark:text-gray-400 text-center mb-6 leading-tight">How would you like us to contact you for delivery?</p>
                                        
                                        <div className="flex flex-col gap-3">
                                            <button onClick={handleWhatsAppSelect} className="flex items-center justify-center gap-2 w-full py-3 px-4 bg-[#25D366] hover:bg-[#20bd5a] text-white rounded-lg text-[14px] font-medium transition-colors">
                                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                                                I have WhatsApp
                                            </button>
                                            <button onClick={handleEmailSelect} className="flex items-center justify-center gap-2 w-full py-3 px-4 bg-gray-100 dark:bg-white/10 hover:bg-gray-200 dark:hover:bg-white/20 text-gray-900 dark:text-white rounded-lg text-[14px] font-medium transition-colors border border-gray-300 dark:border-white/10">
                                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                                                Use Email Instead
                                            </button>
                                        </div>
                                        <div className="mt-5 text-center">
                                            <button onClick={() => setCheckoutStep('addons')} className="text-[13px] text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors">Back to Add-ons</button>
                                        </div>
                                    </div>
                                )}

                                {(checkoutStep === 'whatsapp_input' || checkoutStep === 'email_input') && (
                                    <div className="flex flex-col h-full justify-center pb-4">
                                        <h4 className="text-[17px] font-bold text-gray-900 dark:text-white mb-5 text-center">
                                            {checkoutStep === 'whatsapp_input' ? 'WhatsApp Number' : 'Email Address'}
                                        </h4>
                                        
                                        <div className="mb-6">
                                            {checkoutStep === 'whatsapp_input' ? (
                                                <input 
                                                    type="tel" 
                                                    placeholder="+91 Phone number" 
                                                    value={contactInput}
                                                    onChange={(e) => setContactInput(e.target.value.replace(/[^\d+\s-]/g, ''))}
                                                    className="w-full px-3 py-3 bg-white/60 dark:bg-black/40 border border-gray-300 dark:border-white/20 rounded-lg text-gray-900 dark:text-white outline-none focus:border-[#FF9500] text-sm text-center"
                                                    autoFocus
                                                />
                                            ) : (
                                                <input 
                                                    type="email" 
                                                    placeholder="your@email.com" 
                                                    value={contactInput}
                                                    onChange={(e) => setContactInput(e.target.value)}
                                                    className="w-full px-3 py-3 bg-white/60 dark:bg-black/40 border border-gray-300 dark:border-white/20 rounded-lg text-gray-900 dark:text-white outline-none focus:border-[#FF9500] text-sm text-center"
                                                    autoFocus
                                                />
                                            )}
                                        </div>
                                        
                                        <div className="flex flex-col gap-3 mt-auto shrink-0 -mx-6 -mb-6">
                                            <GlowButton 
                                                onClick={() => {
                                                    if (!contactInput || contactInput.trim() === countryCode.trim()) return alert('Please fill in your details');
                                                    setIsProcessing(true);
                                                    handleRazorpayPayment(contactType, contactInput, '');
                                                }} 
                                                variant="primary" 
                                                className="w-full justify-center text-sm font-bold !rounded-none !rounded-b-[calc(16px-1px)] h-12"
                                                disabled={isProcessing}
                                            >
                                                {isProcessing ? 'Processing...' : `Pay ₹ ${totalPrice.toLocaleString()}`}
                                            </GlowButton>
                                            <div className="absolute top-4 left-4">
                                                <button onClick={() => setCheckoutStep('contact_choice')} className="text-sm font-medium transition-colors text-gray-500 hover:text-gray-900 dark:hover:text-white">Back</button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </BorderGlow>
        </motion.div>
    );
}

export default function PricingSection({ isGameswap }) {
    const { theme } = useTheme();
    const { t } = useLanguage();
    const isDark = theme === 'dark';
    const bgColor = isDark ? '#111111' : '#ffffff';
    const primaryColor = isGameswap ? '#ec4899' : '#FF9500';
    const glowColors = isGameswap ? ['#ec4899', '#db2777', '#be185d'] : ['#FF9500', '#ff6b00', '#ffcc44'];
    
    const [gamerPackagesData, setGamerPackagesData] = useState(GAMER_PACKAGES_DATA);
    const [gamerCategories, setGamerCategories] = useState(GAMER_CATEGORIES);

    const activeCategories = isGameswap ? gamerCategories : CATEGORIES;
    const [bgmiPackagesData, setBgmiPackagesData] = useState(PACKAGES_DATA);
    
    useEffect(() => {
        if (!isGameswap) {
            const generated = {};
            CATEGORIES.forEach(cat => {
                generated[cat] = [];
                const templates = PACKAGES_DATA[cat] || [];
                if (templates.length > 0) {
                    for (let dayOffset = 0; dayOffset < 3; dayOffset++) {
                        const date = new Date();
                        date.setDate(date.getDate() + dayOffset);
                        const dateStr = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
                        let displayDate = dateStr;
                        if (dayOffset === 0) displayDate = `Today, ${dateStr}`;
                        else if (dayOffset === 1) displayDate = `Tomorrow, ${dateStr}`;

                        const matchesCount = 4 + Math.floor(Math.random() * 5); 
                        for (let i = 0; i < matchesCount; i++) {
                            const template = templates[i % templates.length];
                            const hour = 10 + Math.floor((i / matchesCount) * 12);
                            const ampm = hour >= 12 ? 'PM' : 'AM';
                            const displayHour = hour > 12 ? hour - 12 : hour;
                            generated[cat].push({
                                ...template,
                                docId: `${cat}_${dayOffset}_${i}`,
                                matchDate: displayDate,
                                name: `${template.name} - Match ${i + 1}`,
                                badge: `${displayHour}:00 ${ampm}`,
                                badgeColor: 'orange',
                            });
                        }
                    }
                }
            });
            setBgmiPackagesData(generated);
        }
    }, [isGameswap]);

    const activePackages = isGameswap ? gamerPackagesData : bgmiPackagesData;
    
    const [activeTab, setActiveTab] = useState(activeCategories[0]);
    const [flippedCardName, setFlippedCardName] = useState(null);
    const [visibleCount, setVisibleCount] = useState(20);
    const [searchQuery, setSearchQuery] = useState('');
    const [comboMode, setComboMode] = useState(false);
    const [selectedComboCards, setSelectedComboCards] = useState([]);
    const [isProcessingCombo, setIsProcessingCombo] = useState(false);
    
    const { gamerUser, unlockGames } = useGamerAuth();
    const [showGamerAuth, setShowGamerAuth] = useState(false);
    const [pendingCheckout, setPendingCheckout] = useState(null);

    const handleComboPayment = async () => {
        if (!window.Razorpay) {
            alert('Razorpay SDK not loaded');
            return;
        }

        const totalComboPrice = selectedComboCards.reduce((acc, card) => acc + (card.combo_price ?? card.basePrice ?? 0), 0);
        if (totalComboPrice <= 0) return;

        setIsProcessingCombo(true);
        try {
            const res = await fetch('https://rpgridlabsprod.gridlabsproduction.workers.dev/api/create-order', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ amount: totalComboPrice * 100, currency: 'INR', receipt: `combo_${Date.now()}` })
            });
            const orderData = await res.json();
            if (!res.ok) {
                throw new Error(orderData.error?.description || orderData.error || 'Failed to create order');
            }

            const options = {
                key: 'rzp_live_T58W4XHqjFJneN',
                amount: orderData.amount,
                currency: orderData.currency,
                name: 'GridLabs Production',
                description: `Payment for Gamer Combo (${selectedComboCards.length} items)`,
                order_id: orderData.id,
                handler: async function (response) {
                    try {
                        const verifyRes = await fetch('https://rpgridlabsprod.gridlabsproduction.workers.dev/api/verify-payment', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                razorpay_order_id: response.razorpay_order_id,
                                razorpay_payment_id: response.razorpay_payment_id,
                                razorpay_signature: response.razorpay_signature
                            })
                        });
                        const verifyData = await verifyRes.json();
                        if (verifyData.success) {
                            alert('Combo Payment successful!');
                            
                            let text = `Hi Akshar, I have successfully paid for a *GAMER COMBO*.\n\n`;
                            text += `*Payment Details:*\n`;
                            text += `- Amount Paid: ₹ ${totalComboPrice.toLocaleString()}\n`;
                            text += `- Payment ID: ${response.razorpay_payment_id}\n\n`;
                            
                            text += `*Selected Games (${selectedComboCards.length}):*\n`;
                            selectedComboCards.forEach(card => {
                                text += `- ${card.name} (₹ ${(card.basePrice || 0).toLocaleString()})\n`;
                            });
                            
                            text += `\nPlease process my combo order.`;
                            
                            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                            const waUrl = isMobile 
                                ? `whatsapp://send?phone=919518159114&text=${encodeURIComponent(text)}`
                                : `https://web.whatsapp.com/send?phone=919518159114&text=${encodeURIComponent(text)}`;
                            
                            await unlockGames(selectedComboCards.map(c => c.docId || String(c.gameswap_id) || c.name));
                            alert('Combo unlocked and added to your GAMER profile!');
                            window.location.href = waUrl;
                            
                            setComboMode(false);
                            setSelectedComboCards([]);
                        } else {
                            alert('Payment verification failed!');
                        }
                    } catch (error) {
                        alert('Error verifying payment');
                    } finally {
                        setIsProcessingCombo(false);
                    }
                },
                prefill: {
                    name: 'Gamer',
                    email: 'combo_buyer@gridlabsprod.com',
                    contact: '9999999999'
                },
                theme: {
                    color: '#ec4899'
                }
            };
            const rzp = new window.Razorpay(options);
            rzp.on('payment.failed', function (response) {
                alert(`Payment Failed: ${response.error.description}`);
                setIsProcessingCombo(false);
            });
            rzp.on('payment.modal.closed', function() {
                setIsProcessingCombo(false);
            });
            rzp.open();
        } catch (error) {
            console.error("Payment setup failed:", error);
            alert(error.message);
            setIsProcessingCombo(false);
        }
    };

    useEffect(() => {
        setFlippedCardName(null);
        setVisibleCount(20);
        if (activeTab !== 'TOP SELLERS' && activeTab !== 'NEW RELEASES') {
            setComboMode(false);
            setSelectedComboCards([]);
        }
    }, [activeTab]);

    useEffect(() => {
        if (!isGameswap) return;
        const handleScroll = () => {
            if (window.scrollY < window.innerHeight * 0.5) {
                setVisibleCount(20);
            }
        };
        const handleClickOutside = (e) => {
            const isCard = e.target.closest('.pricing-card-container');
            if (!isCard) {
                setFlippedCardName(null);
            }
            const isSearch = e.target.closest('.pricing-search-container');
            const isButton = e.target.closest('button');
            const isInput = e.target.closest('input');
            if (!isCard && !isSearch && !isButton && !isInput) {
                setSearchQuery('');
            }
        };
        window.addEventListener('scroll', handleScroll);
        document.addEventListener('pointerdown', handleClickOutside);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('pointerdown', handleClickOutside);
        };
    }, [isGameswap]);

    useEffect(() => {
        if (isGameswap) {
            const fetchGamerData = async () => {
                try {
                    const cachedData = localStorage.getItem('gameswapData_v7');
                    if (cachedData) {
                        const parsed = JSON.parse(cachedData);
                        if (parsed.categories && parsed.packages) {
                            setGamerCategories(parsed.categories);
                            setGamerPackagesData(parsed.packages);
                            setActiveTab(parsed.categories[0]);
                            // Stale-while-revalidate: we don't return here. 
                            // We let the code continue to fetch fresh data in the background.
                        }
                    }

                    const { collection, getDocs, doc, getDoc } = await import('firebase/firestore');
                    
                    // Fetch categories mapping first
                    const metaDocRef = doc(db, 'gameswap', 'data', 'meta', 'categories');
                    const metaDocSnap = await getDoc(metaDocRef);
                    let catMapping = { 1: "TOP SELLERS", 2: "NEW RELEASES", 3: "MEGA BUNDLES", 4: "SUBSCRIPTIONS" };
                    if (metaDocSnap.exists()) {
                        catMapping = metaDocSnap.data();
                    }
                    
                    const activeCatsList = Object.keys(catMapping)
                        .sort((a, b) => Number(a) - Number(b))
                        .map(k => catMapping[k]);

                    const coversSnap = await getDocs(collection(db, 'gameswap', 'data', 'covers'));
                    const bundlesSnap = await getDocs(collection(db, 'gameswap', 'data', 'bundles'));
                    const subscriptionsSnap = await getDocs(collection(db, 'gameswap', 'data', 'subscriptions'));
                    
                    const packages = {};
                    activeCatsList.forEach(c => packages[c] = []);
                    
                    const processDocs = (snap, folder) => {
                        if (snap.empty) return;
                        snap.docs.forEach((d) => {
                            const data = d.data();
                            const catId = data.category || 1;
                            const cat = catMapping[catId] || catMapping[1];
                            
                            // Enforce strict folder rules to prevent bleeding
                            const isMegaBundles = cat === "MEGA BUNDLES";
                            const isSubscriptions = cat === "SUBSCRIPTIONS";
                            
                            if (folder === 'covers' && (isMegaBundles || isSubscriptions)) return;
                            if (folder === 'bundles' && !isMegaBundles) return;
                            if (folder === 'subscriptions' && !isSubscriptions) return;

                            if (packages[cat]) {
                                packages[cat].push({
                                    docId: d.id,
                                    gameswap_id: data.gameswap_id,
                                    folder: folder,
                                    category: cat,
                                    name: data.name || data.gameswap_id || d.id,
                                    badge: data.badge || null,
                                    badgeColor: 'orange', // Removed from DB, hardcoded to orange
                                    featured: !!data.featured,
                                    price: `₹ ${(data.price || 0).toLocaleString()}`,
                                    basePrice: data.price || 0,
                                    combo_price: data.combo_price ?? null,
                                    priceSub: 'lifetime',
                                    poster: `https://gameswap.gridlabsproduction.workers.dev/${folder}/${data.gameswap_id}.webp`,
                                    cta: 'Buy Now',
                                    addons: data.options ? data.options.map((opt, j) => ({
                                        id: `opt_${j}`,
                                        name: opt.name,
                                        price: opt.price
                                    })) : [],
                                    btnStyle: data.featured ? 'solid' : 'outline',
                                });
                            }
                        });
                    };

                    processDocs(coversSnap, 'covers');
                    processDocs(bundlesSnap, 'bundles');
                    processDocs(subscriptionsSnap, 'subscriptions');
                    
                    // Filter empty categories, but preserve order based on activeCatsList
                    const activeCats = activeCatsList.filter(c => packages[c].length > 0);
                    
                    if (activeCats.length > 0) {
                        setGamerCategories(activeCats);
                        setGamerPackagesData(packages);
                        // If we didn't have cache, set the active tab to the first category
                        if (!cachedData) {
                            setActiveTab(activeCats[0]);
                        }
                        
                        // Save to cache
                        localStorage.setItem('gameswapData_v7', JSON.stringify({ categories: activeCats, packages }));
                    }
                } catch (err) {
                    console.error("Error fetching gameswap data:", err);
                }
            };
            fetchGamerData();
        } else {
            setActiveTab(CATEGORIES[0]);
        }
    }, [isGameswap]);

    useEffect(() => {
        if (!isGameswap) {
            setFlippedCardName(null);
            setVisibleCount(20);
        }
    }, [activeTab, isGameswap]);

    const isGamerStyle = true;
    return (
        <section id="pricing" className="py-20 bg-transparent relative z-10">
            <div className="mx-auto max-w-7xl px-4">

                {/* Tabs & Search */}
                <div className={`flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 mb-10`}>
                    <div className="flex flex-wrap justify-start gap-2 w-full lg:w-auto">
                        {activeCategories.map((cat) => (
                            <button
                                key={cat}
                                onClick={() => { setActiveTab(cat); setSearchQuery(''); }}
                                className={`px-4 xl:px-6 py-2 xl:py-2.5 rounded-[50px] text-[11px] xl:text-sm font-semibold whitespace-nowrap transition-all duration-300 ${
                                    activeTab !== cat ? 'bg-white dark:bg-[#1a1a1a] text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-800 hover:border-[#FF9500] dark:hover:border-[#FF9500]' : ''
                                }`}
                                style={(activeTab === cat) ? { backgroundColor: primaryColor, color: 'white', borderColor: primaryColor } : {}}
                            >
                                {cat}
                            </button>
                        ))}
                    </div>
                        <div className="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto shrink-0 ml-auto justify-end">
                            {isGameswap && (activeTab === 'TOP SELLERS' || activeTab === 'NEW RELEASES') && (
                                comboMode ? (
                                    <GlowButton
                                        variant="primary"
                                        borderRadius="9999px"
                                        onClick={() => {
                                            setComboMode(false);
                                            setSelectedComboCards([]);
                                        }}
                                        className="w-full sm:w-auto !gap-1.5 xl:!gap-2 !px-3 xl:!px-4 !py-2 xl:!py-2.5 !h-auto text-[10px] xl:text-xs tracking-widest"
                                    >
                                        <span className="w-2 h-2 rounded-full shrink-0 bg-black animate-pulse"></span>
                                        <span className="whitespace-nowrap">COMBO BUY</span>
                                    </GlowButton>
                                ) : (
                                    <button 
                                        onClick={() => {
                                            setComboMode(true);
                                            setSelectedComboCards([]);
                                        }}
                                        className="flex w-full sm:w-auto items-center justify-center gap-1.5 xl:gap-2 px-3 xl:px-4 py-2 xl:py-2.5 rounded-full text-[10px] xl:text-xs font-bold tracking-widest transition-all duration-300 border bg-gray-100 dark:bg-white/5 border-gray-200 dark:border-white/10 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-white/10"
                                    >
                                        <span className="w-2 h-2 rounded-full shrink-0 bg-gray-500"></span>
                                        <span className="whitespace-nowrap">COMBO BUY</span>
                                    </button>
                                )
                            )}
                            <div className="pricing-search-container relative w-full sm:w-40 lg:w-48 xl:w-64">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="w-full px-4 py-2 xl:py-2.5 bg-gray-100 dark:bg-black/40 border border-gray-200 dark:border-gray-800 focus:border-pink-500 rounded-[50px] text-xs xl:text-sm text-gray-900 dark:text-white outline-none transition-all duration-300"
                            />
                            <svg className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </div>
                        </div>
                </div>

                {/* Cards Grid */}
                <AnimatePresence mode="wait">
                    <motion.div
                        key={searchQuery ? 'search' : activeTab}
                        className={`mt-4 grid gap-3 sm:gap-4 md:gap-5 grid-cols-1 sm:grid-cols-2 ${isGameswap ? 'lg:grid-cols-4 xl:grid-cols-5' : 'lg:grid-cols-3 xl:grid-cols-3'}`}
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                        exit={{ opacity: 0, y: -20, transition: { duration: 0.2 } }}
                    >
                        {(() => {
                            let pkgs = activePackages[activeTab] || [];
                            if (searchQuery.trim() !== '') {
                                const query = searchQuery.toLowerCase().trim();
                                const allPkgs = Object.values(activePackages).flat();
                                const results = allPkgs.filter(plan => {
                                    const nameMatch = plan.name?.toLowerCase().includes(query);
                                    const idMatch = String(plan.gameswap_id).toLowerCase().includes(query) || String(plan.docId).toLowerCase().includes(query);
                                    return nameMatch || idMatch;
                                });
                                const uniqueResults = Array.from(new Map(results.map(item => [item.docId || item.gameswap_id, item])).values());
                                pkgs = uniqueResults.length > 0 ? uniqueResults : (activePackages["NEW RELEASES"] || activePackages[activeCategories[0]] || []);
                            }
                            const renderCard = (plan) => (
                                <PricingCard 
                                    key={plan.docId || plan.name} 
                                    plan={plan} 
                                    bgColor={bgColor} 
                                    isGameswap={isGameswap}
                                    activeTab={searchQuery ? 'search' : activeTab}
                                    isFlipped={flippedCardName === (plan.docId || plan.name)}
                                    onFlip={() => setFlippedCardName(plan.docId || plan.name)}
                                    onUnflip={() => setFlippedCardName(null)}
                                    comboMode={comboMode}
                                    isSelected={selectedComboCards.some(c => (c.docId || c.name) === (plan.docId || plan.name))}
                                    onRequestLogin={(p) => { setPendingCheckout(p); setShowGamerAuth(true); }}
                                    pendingCheckout={pendingCheckout}
                                    clearPendingCheckout={() => setPendingCheckout(null)}
                                    onToggleSelect={() => {
                                        const id = plan.docId || plan.name;
                                        if (selectedComboCards.some(c => (c.docId || c.name) === id)) {
                                            setSelectedComboCards(prev => prev.filter(c => (c.docId || c.name) !== id));
                                        } else {
                                            setSelectedComboCards(prev => [...prev, plan]);
                                        }
                                    }}
                                />
                            );

                            if (!isGameswap && searchQuery.trim() === '') {
                                const grouped = {};
                                pkgs.slice(0, visibleCount).forEach(pkg => {
                                    const d = pkg.matchDate || 'Upcoming Matches';
                                    if (!grouped[d]) grouped[d] = [];
                                    grouped[d].push(pkg);
                                });
                                return Object.entries(grouped).map(([date, items]) => (
                                    <React.Fragment key={date}>
                                        <div className="col-span-full flex items-center gap-4 mt-6 mb-1">
                                            <h3 className="text-xl font-bold text-gray-900 dark:text-white uppercase tracking-wider">{date}</h3>
                                            <div className="h-px bg-gray-200 dark:bg-white/10 flex-1"></div>
                                        </div>
                                        {items.map(renderCard)}
                                    </React.Fragment>
                                ));
                            }

                            return pkgs.slice(0, visibleCount).map(renderCard);
                        })()}
                    </motion.div>
                </AnimatePresence>

                {/* Load More Button */}
                {(() => {
                    let totalLen = (activePackages[activeTab] || []).length;
                    if (searchQuery.trim() !== '') {
                        const query = searchQuery.toLowerCase().trim();
                        const allPkgs = Object.values(activePackages).flat();
                        const results = allPkgs.filter(plan => {
                            const nameMatch = plan.name?.toLowerCase().includes(query);
                            const idMatch = String(plan.gameswap_id).toLowerCase().includes(query) || String(plan.docId).toLowerCase().includes(query);
                            return nameMatch || idMatch;
                        });
                        const uniqueResults = Array.from(new Map(results.map(item => [item.docId || item.gameswap_id, item])).values());
                        totalLen = uniqueResults.length > 0 ? uniqueResults.length : (activePackages["NEW RELEASES"]?.length || 0);
                    }
                    
                    return totalLen > visibleCount && (
                        <div className="mt-12 flex justify-center">
                            <button
                                onClick={() => setVisibleCount(prev => prev + 20)}
                                className="px-8 py-3 rounded-full text-sm font-bold tracking-wider uppercase transition-all duration-300 active:scale-95 bg-gray-100 dark:bg-transparent text-pink-500 border border-pink-500/50 hover:bg-pink-100 dark:hover:bg-pink-500/10 hover:border-pink-500 hover:shadow-[0_0_15px_rgba(236,72,153,0.4)]"
                            >
                                Load More
                            </button>
                        </div>
                    );
                })()}

                {comboMode && selectedComboCards.length > 0 && (
                    <motion.div 
                        initial={{ opacity: 0, y: 50, x: "-50%" }}
                        animate={{ opacity: 1, y: 0, x: "-50%" }}
                        exit={{ opacity: 0, y: 50, x: "-50%" }}
                        className="fixed bottom-8 left-1/2 z-[999] bg-white/90 dark:bg-[#111]/90 backdrop-blur-xl border border-pink-500/50 px-6 py-4 rounded-2xl shadow-[0_10px_40px_rgba(236,72,153,0.3)] flex items-center gap-6 w-[90%] sm:w-auto sm:min-w-[400px] justify-between"
                    >
                        <div className="flex flex-col">
                            <span className={`text-xs font-bold tracking-widest ${selectedComboCards.length >= 5 ? 'text-green-500 dark:text-green-400' : 'text-gray-500 dark:text-gray-400'}`}>
                                {selectedComboCards.length} / 5 MINIMUM SELECTED
                            </span>
                            <span className="text-2xl font-black text-gray-900 dark:text-white">
                                ₹ {selectedComboCards.reduce((acc, card) => acc + (card.combo_price ?? card.basePrice ?? 0), 0).toLocaleString()}
                            </span>
                        </div>
                        <button 
                            disabled={selectedComboCards.length < 5 || isProcessingCombo}
                            onClick={() => {
                                if (!gamerUser) {
                                    setPendingCheckout('combo');
                                    setShowGamerAuth(true);
                                } else {
                                    handleComboPayment();
                                }
                            }}
                            className={`px-6 sm:px-8 py-3 font-black text-sm tracking-widest uppercase rounded-xl transition-all shrink-0 ${
                                selectedComboCards.length >= 5 && !isProcessingCombo
                                    ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white hover:opacity-90 shadow-[0_0_20px_rgba(236,72,153,0.4)] active:scale-95 cursor-pointer' 
                                    : 'bg-gray-800 text-gray-500 cursor-not-allowed'
                            }`}
                        >
                            {isProcessingCombo ? 'PROCESSING...' : 'BUY COMBO'}
                        </button>
                    </motion.div>
                )}
            </div>
            {isGameswap && (
                <GamerAuthModal 
                    isOpen={showGamerAuth} 
                    onClose={() => { setShowGamerAuth(false); setPendingCheckout(null); }} 
                    onSuccess={() => {
                        if (pendingCheckout === 'combo') {
                            handleComboPayment();
                        }
                        // For individual items, PricingCard's useEffect handles it
                    }} 
                />
            )}
        </section>
    );
}
